import ServiceBase from '../ServiceBase';

export default class BannerService extends ServiceBase {

    getProjectAdverts(pageSize, pageIndex) {
        return this.request('get', 'admin/banner/getProjectAdverts', {
            pageSize,
            pageIndex,
        });
    }

    getProjectAdvert(projectAdvertID) {
        return this.request('get', 'admin/banner/getProjectAdvert', {
            projectAdvertID,
        });
    }

    deleteProjectAdvert(projectAdvertID) {
        return this.request('post', 'admin/banner/deleteProjectAdvert', {
            projectAdvertID,
        });
    }

    createProjectAdvert(projectAdvert) {
        return this.request('post', 'admin/banner/createProjectAdvert', {
            ...projectAdvert,
        });
    }

    updateProjectAdvert(projectAdvert) {
        return this.request('post', 'admin/banner/updateProjectAdvert', {
            ...projectAdvert,
        });
    }

    getInfoBanners() {
        return this.request('get', 'admin/banner/getInfoBanners');
    }

    getInfoBanner(infoBannerID) {
        return this.request('get', 'admin/banner/getInfoBanner', {
            infoBannerID,
        });
    }

    deleteInfoBanner(infoBannerID) {
        return this.request('post', 'admin/banner/deleteInfoBanner', {
            infoBannerID,
        });
    }

    addInfoBanner(infoBanner) {
        return this.request('post', 'admin/banner/addInfoBanner', {
            ...infoBanner,
        });
    }

    updateInfoBanner(infoBanner) {
        return this.request('post', 'admin/banner/updateInfoBanner', {
            ...infoBanner,
        });
    }

    duplicateInfoBanner(infoBannerID) {
        return this.request('post', 'admin/banner/duplicateInfoBanner', {
            infoBannerID,
        });
    }

    reorderInfoBanners({ infoBannerID, sortOrder }) {
        return this.request('post', 'admin/banner/reorderInfoBanners', {
            infoBannerID,
            sortOrder,
        });
    }
}
